import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TableHeader from 'components/Table/TableHeader'

class TableHead extends Component {
  renderTableHeaders () {
    return this.props.headers.map((header, index) => {
      return (
        <TableHeader
          title={header.title}
          key={index}
          handleOnClick={header.onClick}
          currentSelected={this.props.currentSelected}
        />
      )
    })
  }

  render () {
    return (
      <thead className={this.props.className}>
        <tr className='grid p-16 gap-x-16 grid-rows-[32px] items-center bg-midnight-black-5 font-normal' style={{ gridTemplateColumns: this.props.gridTemplateColumns }}>
          {this.renderTableHeaders()}
        </tr>
      </thead>
    )
  }
}

TableHead.propTypes = {
  headers: PropTypes.array,
  gridTemplateColumns: PropTypes.string
}

export default TableHead
